// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__37FyX","upload":"Small_upload__1f--s","imageWrap":"Small_imageWrap__1nVl_","removeBtn":"Small_removeBtn__dyEnO"};